// extracted by mini-css-extract-plugin
export default {"container":"modalReclamo_container__I-dT7","form":"modalReclamo_form__Np5WC"};